import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id CEC57068-18E1-42DA-8788-EDCC009DFB7D
 * name comma-box
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comma-box.svg
 * tags
 */
export const CommaBoxIcon = createSvgIcon(<><path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M15,13V7H9V13H12L10,17H13L15,13Z" /></>, 'CommaBoxIcon');
export default CommaBoxIcon